import { useEffect, useState } from "react";
import BlogCard from "../components/BlogCard";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";
import AOS from "aos";
import "aos/dist/aos.css";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

function Blog() {
  const [posts, setPosts] = useState([]);
  const [visibleCount, setVisibleCount] = useState(6);
  const [loading, setLoading] = useState(true);

  // Fetch blogs from backend
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${BASE_URL}/api/blogs`); // public blogs endpoint
        if (!res.ok) throw new Error("Failed to fetch blogs");
        const data = await res.json();
        setPosts(data);
      } catch (err) {
        console.error("Error fetching blogs:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  // Animate on scroll
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  // Load More Handler
  const loadMore = () => {
    setVisibleCount((prev) => {
      const nextCount = prev + 6;
      return nextCount >= posts.length ? posts.length : nextCount;
    });
  };

  return (
    <>
      {/* Breadcrumbs */}
      <div className="max-w-6xl mx-auto px-4">
        <Breadcrumbs />
      </div>

      {/* Hero */}
      <section className="py-20 bg-blue-50 text-center">
        <div className="max-w-3xl mx-auto px-4">
          <h1 className="text-4xl font-bold text-blue-700">Our Blog</h1>
          <p className="text-gray-600 text-lg mt-2">
            Tips, stories, and updates from the Exudee Hampers team.
          </p>
        </div>
      </section>

      {/* Blog Posts */}
      <section
        className="py-16 px-4 max-w-6xl mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-6"
        data-aos="fade-up"
      >
        {posts.slice(0, visibleCount).map((post) => (
          <BlogCard
            key={post._id}
            image={post.image}
            title={post.title}
            excerpt={post.excerpt}
            category={post.category}
            to={`/blog/${post.slug}`}
            commentsCount={post.commentsCount || 0}
            likesCount={post.likes || 0}
          />
        ))}

        {/* Empty State */}
        {!loading && posts.length === 0 && (
          <div className="col-span-full text-center text-gray-500">
            No blog posts found.
          </div>
        )}
      </section>

      {/* Load More Button */}
      {visibleCount < posts.length && (
        <div className="flex justify-center mb-12">
          <button
            onClick={loadMore}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded font-semibold shadow-md transition duration-200"
          >
            Load More Posts
          </button>
        </div>
      )}

      {/* Footer */}
      <div data-aos="fade-up">
        <Footer />
      </div>
    </>
  );
}

export default Blog;
